module.exports = __webpack_public_path__ + "static/TruenoBd-9accd78cca46378c46435e5bce227ac1.woff";